import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Button } from 'primereact/button';
import { AjoutLocation } from "./ajoutLocation";
import { ModifierLocation } from "./modifierLocation";
import { InfoLocation } from "./infoLocation";
// import { AjoutFacture } from "./ajoutFacture";
import correctEncoding from "../../correctEncoding";
// import "../locationStyle/locationStockage.css";
import { SuprLoc } from "./suprLocation";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditOutlineIcon from "@mui/icons-material/ModeEditOutline";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Box, Modal, TextField, Tooltip, Grid } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { SelectRetard } from "./selectRetard";
import EuroIcon from "@mui/icons-material/Euro";
import { Sidebar } from "primereact/sidebar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Headerlocation from "./headerLocation";



export const LocationStockage = () => {


  const apiUrl = process.env.REACT_APP_API_URL;

  const [visibleBottom, setVisibleBottom] = useState(false);
  const isMobilePortrait = useMediaQuery("(max-width:1207px)  ");

  const [currentPage, setCurrentPage] = useState(1);
  var itemsPerPage = 0;
  if (isMobilePortrait) {
    itemsPerPage = 5;
  } else {
    itemsPerPage = 6;
  }

  const [filtre, setFiltre] = useState("enCours");
  const [limRetard, setLimRetard] = useState("");
  const [idInfoLoc, setIdInfoLoc] = useState("");
  const [afficherAjoutLoc, setAfficherAjoutLoc] = useState(false);
  const [afficherAjoutPaie, setAfficherAjoutPaie] = useState(false);
  const [selectedIdPaie, setSelectedIdPaie] = useState("");
  const [selectedNomClientP, setSelectedNomClientP] = useState("");
  const [modifierLocation, setModifierLocation] = useState(false);
  const [ajoutFact, setAjoutFact] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedNomCli, setSelectedNomCli] = useState("");
  const [locations, setLocations] = useState([]);
  const [copiedText, setCopiedText] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [suprLoc, setSuprLoc] = useState(false);
  const [stockageALibrerer, setStockageALibrerer] = useState("");
  const searchTextFieldRef = useRef(null);

  //récupération de la liste de location
  const recupererListeLoc = () => {

    try {
      axios.get(`${apiUrl}IHM/api/location.php`).then((response) => {
        const locationData = response.data;
        setLocations(locationData);
      });
    } catch (error) {
      if (error.response) {
        console.error("Erreur de réponse du serveur :", error.response.data);
      } else if (error.request) {
        console.error("Pas de réponse du serveur :", error.request);
      } else {
        console.error("Erreur lors de la requête :", error.message);
      }
    }
  };



  const paie = (idLoc, nomClient) => {
    // console.log(`paiement de ${idLoc}`);
    setAfficherAjoutPaie(true);
    setSelectedIdPaie(idLoc);
    setSelectedNomClientP(nomClient);
  };

  //donne un format à tous les Dates
  const formattedDate = (dateRecup) => {
    if (dateRecup === "0000-00-00" || dateRecup === "" || dateRecup === null) {
      return ``;
    }

    const date = new Date(dateRecup);

    // Options pour le formatage
    const options = {
      day: 'numeric',   // Jour du mois
      month: 'numeric',    // Mois complet (janvier, février, etc.)
      year: 'numeric'   // Année complète
    };

    // Formatage de la date avec les options spécifiées
    return date.toLocaleDateString('fr-FR', options);
  };

  const copyToClipboard = (text) => {
    if (text !== "") {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            setCopiedText(text);
            console.log("copie annnh", text);
            setOpenSnackbar(true);
          })
          .catch((error) => {
            console.error(
              "Erreur lors de la copie dans le presse-papiers : ",
              error
            );
          });
      } else {
        // Utiliser l'API de sélection de texte comme solution de secours
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        setCopiedText(text);
        setOpenSnackbar(true);
      }
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  useEffect(() => {
    // setFiltre("enCours");
    setIdSearch("");
    setLimRetard("");
  }, [modifierLocation, afficherAjoutLoc, suprLoc]);
  const texteAffiche =
    filtre === "tard"
      ? "Locations avec de paiements en retard"
      : filtre === "tardR"
        ? 'Locations "réservés" sans paiements'
        : filtre === "tardE"
          ? 'Locations "entrées" sans paiements'
          : filtre === "enCours"
            ? "Locations en cours"
            : filtre === "enRegle"
              ? "Locations payés à jour"
              : "Toutes les locations";
  const [idSearch, setIdSearch] = useState("");
  const [idStock, setIdStock] = useState("");
  const indexOfLastItem = Math.min(
    currentPage * itemsPerPage,
    locations.length
  );
  const indexOfFirstItem = Math.min(
    indexOfLastItem - itemsPerPage,
    locations.length
  );

  const currentLocs = locations.slice(indexOfFirstItem, indexOfLastItem);

  const LocationListe = () => {
    return (
      <div>
        {/* <Toast ref={toast} /> */}
        <div className="toutCL">
          {afficherAjoutLoc && (
            <AjoutLocation
              idSelected={selectedLocation}
              afficherAjoutLoc={afficherAjoutLoc}
              setAfficherAjoutLoc={setAfficherAjoutLoc}
            />
          )}
          {modifierLocation && (
            <ModifierLocation
              idSelected={selectedLocation}
              setModifierLocation={setModifierLocation}
              setFiltre={setFiltre}
              onClose={() => {
                setModifierLocation(false);
                recupererListeLoc("");
              }}
            />
          )}
          {suprLoc && (
            <SuprLoc
              setSuprLoc={setSuprLoc}
              idSelected={selectedLocation}
              stockageALibrerer={stockageALibrerer}
            />
          )}
          {!isMobilePortrait && (
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={1}>
                <Grid item xs={12} md={9}>
                  <div className="flex">
                    <div className="gaucheStock">
                      <div>
                        <div className="center">
                          {/* Copie d'élément */}
                          <div>
                            <Snackbar
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                              }}
                              open={openSnackbar}
                              autoHideDuration={3000}
                              onClose={handleCloseSnackbar}
                              message={`Copie réussie de " ${
                                copiedText === "location.mail"
                                  ? "e-mail"
                                  : copiedText
                              } "`}
                              action={
                                <React.Fragment>
                                  <IconButton
                                    size="small"
                                    aria-label="close"
                                    color="inherit"
                                    onClick={handleCloseSnackbar}
                                  >
                                    <CloseIcon fontSize="small" />
                                  </IconButton>
                                </React.Fragment>
                              }
                            />
                          </div>
                        </div>

                        <div>
                          <div>
                            {" "}
                            <div>
                              {/* <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <h3
                                  className="titreTableau"
                                  className="m-0"
                                  style={{
                                    fontSize: "1.6rem",
                                    fontWeight: "700",
                                    letterSpacing: "-0.5px",
                                  }}
                                >
                                  {texteAffiche}
                                </h3>
                                <Button
                                  label="Location"
                                  icon="pi pi-plus"
                                  severity="info"
                                  style={{
                                    backgroundColor: "#0971b7",
                                    border: "none",
                                    color: "#ffffff",
                                    fontSize: "0.8rem",
                                    fontWeight: "700",
                                    borderRadius: "8px",
                                    padding: "10px 18px",
                                  }}
                                  onClick={() => setAfficherAjoutLoc(true)}
                                />
                              </div> */}

                              <Headerlocation
                                titre={texteAffiche}
                                setAfficherAjoutLoc={setAfficherAjoutLoc}
                              />

                              <DataTable
                                value={locations}
                                paginator
                                rows={10}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                tableStyle={{ minWidth: "50rem" }}
                                scrollable
                                scrollDirection="horizontal"
                                rowClassName={(rowData) =>
                                  ` ${
                                    rowData.idlocation === selectedLocation
                                      ? "rescentCli custom-row-class"
                                      : "custom-row-class"
                                  }`
                                }
                                columnSeparator="   "
                                // paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                                paginatorTemplate={
                                  "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                                }
                                paginatorRight={
                                  <span
                                    style={{
                                      margin: "10px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Résultats : {locations.length}
                                  </span>
                                }
                              >
                                <Column
                                  field="idStockage"
                                  header="Box"
                                  style={{ width: "15%" }}
                                  bodyStyle={{ fontSize: "13px" }}
                                  body={(rowData) => (
                                    <div>
                                      {rowData.idStockage
                                        .split("||")
                                        .join(", ")}
                                    </div>
                                  )}
                                />
                                <Column
                                  className="loc-column-content"
                                  field="idClient"
                                  header="Client"
                                  body={(rowData) => (
                                    <Tooltip
                                      title={
                                        <div>
                                          {rowData.mail !== "" && (
                                            <div
                                              style={{
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              <span>
                                                <ContentCopyIcon
                                                  style={{
                                                    cursor: "pointer",
                                                    padding: "2px",
                                                  }}
                                                  fontSize="small"
                                                  onClick={() =>
                                                    copyToClipboard(
                                                      rowData.mail,
                                                    )
                                                  }
                                                />
                                                <span className="text-sm ">
                                                  {rowData.mail}
                                                </span>
                                              </span>
                                            </div>
                                          )}
                                          {rowData.mail2 !== "" && (
                                            <div
                                              style={{
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              <span className=" ">
                                                <ContentCopyIcon
                                                  style={{
                                                    cursor: "pointer",
                                                    padding: "2px",
                                                  }}
                                                  fontSize="small"
                                                  onClick={() =>
                                                    copyToClipboard(
                                                      rowData.mail2,
                                                    )
                                                  }
                                                />
                                                {rowData.mail2}
                                              </span>
                                            </div>
                                          )}

                                          {rowData.num1 !== "" && (
                                            <div
                                              style={{
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              <span className=" ">
                                                <ContentCopyIcon
                                                  style={{
                                                    cursor: "pointer",
                                                    padding: "2px",
                                                  }}
                                                  fontSize="small"
                                                  onClick={() =>
                                                    copyToClipboard(
                                                      rowData.num1,
                                                    )
                                                  }
                                                />
                                                {rowData.num1}
                                              </span>
                                            </div>
                                          )}

                                          {rowData.num2 !== "" && (
                                            <div
                                              style={{
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              <span className=" ">
                                                <ContentCopyIcon
                                                  style={{
                                                    cursor: "pointer",
                                                    padding: "2px",
                                                  }}
                                                  fontSize="small"
                                                  onClick={() =>
                                                    copyToClipboard(
                                                      rowData.num2,
                                                    )
                                                  }
                                                />
                                                {rowData.num2}{" "}
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      }
                                      arrow
                                    >
                                      <span
                                        className="loc-column-content1"
                                        style={{
                                          padding: "10px",
                                        }}
                                      >
                                        {rowData.idClient}-{" "}
                                        {correctEncoding(rowData.nom)}
                                      </span>
                                    </Tooltip>
                                  )}
                                />
                                <Column
                                  field="dateReservation"
                                  header=" R/E/S"
                                  style={{ width: "20%" }}
                                  bodyStyle={{ fontSize: "13px" }}
                                  body={(rowData) => (
                                    <>
                                      R:{" "}
                                      {formattedDate(rowData.dateReservation)}
                                      <br />
                                      E: {formattedDate(rowData.dateEntree)}
                                      <br />
                                      {filtre !== "enCours" && (
                                        <>
                                          S: {formattedDate(rowData.dateSortie)}
                                          <br />
                                        </>
                                      )}
                                    </>
                                  )}
                                />
                                <Column
                                  style={{ width: "10%" }}
                                  field="loyer"
                                  header="Loyer"
                                  body={(rowData) => (
                                    <div style={{ fontSize: "15px" }}>
                                      {rowData.loyer}€
                                    </div>
                                  )}
                                />
                                <Column
                                  style={{ width: "10%" }}
                                  field="totVolume"
                                  header="Volume"
                                  body={(rowData) => (
                                    <div style={{ fontSize: "15px" }}>
                                      {rowData.totVolume} m³
                                    </div>
                                  )}
                                />
                                {filtre === "tardE" ? (
                                  <Column
                                    field="DateDiffE"
                                    header="Durée depuis l' ENTREE"
                                    body={(rowData) => (
                                      <div>{rowData.DateDiffE} jours </div>
                                    )}
                                  />
                                ) : filtre === "tardR" ? (
                                  <Column
                                    className="loc-column-content"
                                    style={{ width: "20%" }}
                                    bodyStyle={{ fontSize: "13px" }}
                                    field="DateDiffE"
                                    header="Durée depuis la RESERVATION"
                                    body={(rowData) => (
                                      <div>{rowData.DateDiffR} jours </div>
                                    )}
                                  />
                                ) : (
                                  <Column
                                    field="DateDiffE"
                                    header=" Paiement"
                                    style={{ width: "20%" }}
                                    bodyStyle={{ fontSize: "13px" }}
                                    body={(rowData) => (
                                      <div>
                                        {rowData.datePaiePlusRecente
                                          ? ` P : ${formattedDate(
                                              rowData.datePaiePlusRecente,
                                            )} `
                                          : rowData.datePaie}
                                        <br />
                                        {rowData.dateFinPlusRecente
                                          ? `F : ${formattedDate(
                                              rowData.dateFinPlusRecente,
                                            )}  `
                                          : ""}{" "}
                                        <br />
                                        {rowData.DateDiff ? (
                                          <strong>
                                            Retard : {rowData.DateDiff} jours
                                          </strong>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    )}
                                  />
                                )}
                                <Column
                                  className="loc-column-content"
                                  field="noteLocation"
                                  header="Notes"
                                  style={{ width: "25%" }}
                                  bodyStyle={{ fontSize: "15px" }}
                                  body={(rowData) => (
                                    <div>
                                      {correctEncoding(rowData.noteLocation)}
                                    </div>
                                  )}
                                />{" "}
                                <Column
                                  header="Actions"
                                  body={(rowData) =>
                                    localStorage.getItem("pr") === "sad" ||
                                    localStorage.getItem("pr") === "st" ||
                                    localStorage.getItem("pr") === "ad" ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          gap: "5px",
                                        }}
                                      >
                                        <Button
                                          icon="pi pi-pencil"
                                          severity="success"
                                          size="small"
                                          text
                                          raised
                                          onClick={() => {
                                            setSelectedLocation(
                                              rowData.idLocation,
                                            );
                                            setIdInfoLoc(rowData.idLocation);
                                            setSelectedNomCli(rowData.nom);
                                            setIdStock(rowData.idStockage);

                                            setModifierLocation(true);
                                            console.log(
                                              "rowData.idlocation === selectedLocation",
                                              rowData.idlocation ===
                                                selectedLocation,
                                              rowData.idlocation,
                                              "1",
                                              selectedLocation,
                                              "2",
                                            );
                                          }}
                                        />

                                        <Button
                                          icon="pi pi-trash"
                                          severity="danger"
                                          size="small"
                                          text
                                          raised
                                          onClick={() => {
                                            setSelectedLocation(
                                              rowData.idLocation,
                                            );
                                            setStockageALibrerer(
                                              rowData.idStockage,
                                            );
                                            setSuprLoc(true);
                                          }}
                                        />

                                        <Button
                                          icon="pi pi-euro"
                                          severity="contrast"
                                          size="small"
                                          text
                                          raised
                                          onClick={() => {
                                            setIdInfoLoc(rowData.idLocation);
                                            setSelectedNomCli(rowData.nom);
                                            setIdStock(rowData.idStockage);
                                          }}
                                        />
                                      </div>
                                    ) : (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          gap: "5px",
                                        }}
                                      >
                                        <Button
                                          icon="pi pi-euro"
                                          severity="contrast"
                                          size="small"
                                          text
                                          raised
                                          onClick={() => {
                                            setIdInfoLoc(rowData.idLocation);
                                            setSelectedNomCli(rowData.nom);
                                            setIdStock(rowData.idStockage);
                                            setVisibleBottom(true);
                                          }}
                                        />
                                      </div>
                                    )
                                  }
                                />
                              </DataTable>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="droiteStock">
                      <Box
                        sx={{
                          marginLeft: {
                            xs: "10px", // Pour les écrans mobiles (extra small)
                            sm: "10px", // Pour les écrans de taille moyenne (small)
                            md: "10px", // Pour les écrans de taille moyenne (medium)
                            lg: "10px", // Pour les écrans larges (large)
                          },
                        }}
                      >
                        <h2>FILTRE</h2>
                      </Box>
                      <SelectRetard
                        setLocations={setLocations}
                        setFiltre={setFiltre}
                        filtre={filtre}
                        setIdSearch={setIdSearch}
                        idSearch={idSearch}
                        afficherAjoutLoc={afficherAjoutLoc}
                        modifierLocation={modifierLocation}
                        suprLoc={suprLoc}
                        limRetard={limRetard}
                        setLimRetard={setLimRetard}
                      />
                      <div
                        className="infoLoc"
                        style={{
                          width: "80%",
                          textAlign: "center",
                        }}
                      >
                        <InfoLocation
                          idInfoLoc={idInfoLoc}
                          idStock={idStock}
                          selectedNomCli={selectedNomCli}
                        />
                      </div>
                      <br />
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Box>
          )}{" "}
          {isMobilePortrait && (
            <div>
              <div className=" ">
                <div>
                  <div>
                    <Box>
                      <div>
                        <SelectRetard
                          setLocations={setLocations}
                          setFiltre={setFiltre}
                          filtre={filtre}
                          setIdSearch={setIdSearch}
                          idSearch={idSearch}
                          afficherAjoutLoc={afficherAjoutLoc}
                          modifierLocation={modifierLocation}
                          suprLoc={suprLoc}
                          limRetard={limRetard}
                          setLimRetard={setLimRetard}
                        />
                      </div>
                    </Box>
                  </div>
                  <div>
                    <Snackbar
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                      open={openSnackbar}
                      autoHideDuration={3000}
                      onClose={handleCloseSnackbar}
                      message={`Copie réussie de " ${
                        copiedText === "location.mail" ? "e-mail" : copiedText
                      } "`}
                      action={
                        <React.Fragment>
                          <Button
                            color="secondary"
                            size="small"
                            onClick={handleCloseSnackbar}
                          >
                            FERMER
                          </Button>
                          <IconButton
                            size="small"
                            aria-label="close"
                            color="inherit"
                            onClick={handleCloseSnackbar}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </React.Fragment>
                      }
                    />
                  </div>
                  <div>
                    <div>
                      <div
                        className="titreTableau"
                        className="m-0"
                        style={{
                          fontSize: "1.6rem",
                          fontWeight: "700",
                          letterSpacing: "-0.5px",
                        }}
                      >
                        <h3 className="titreTableau ">{texteAffiche}</h3>
                        <Button
                          variant="contained"
                          className="boutonAjouter"
                          label="Location"
                          color="primary"
                          onClick={() => setAfficherAjoutLoc(true)}
                          icon="pi pi-plus"
                          style={{
                            backgroundColor: "#0971b7",
                            border: "none",
                            color: "#ffffff",
                            fontSize: "0.8rem",
                            fontWeight: "700",
                            borderRadius: "8px",
                            padding: "10px 18px",
                          }}
                        />
                      </div>
                      <div>
                        <DataTable
                          value={locations}
                          scrollable
                          paginator
                          rows={10}
                          rowsPerPageOptions={[5, 10, 25, 50]}
                          tableStyle={{ minWidth: "50rem" }}
                          rowClassName={(rowData) =>
                            ` ${
                              rowData.idlocation === selectedLocation
                                ? "rescentCli custom-row-class"
                                : "custom-row-class"
                            }`
                          }
                          columnSeparator="   "
                          // paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                          paginatorTemplate={
                            "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                          }
                          paginatorRight={
                            <span
                              style={{ margin: "10px", fontWeight: "bold" }}
                            >
                              Résultats : {locations.length}
                            </span>
                          }
                        >
                          <Column
                            className="small-font-column"
                            field="idStockage"
                            header="Box"
                            body={(rowData) => (
                              <div>
                                {rowData.idStockage.split("||").join(",")}
                              </div>
                            )}
                          />
                          <Column
                            className="loc-column-content"
                            field="nom"
                            style={{ width: "30%" }}
                            bodyStyle={{ fontSize: "13px" }}
                            header="Client"
                            body={(rowData) => <span>{rowData.nom}</span>}
                          />
                          <Column
                            field="loyer"
                            header="Loyer"
                            body={(rowData) => (
                              <div>
                                {rowData.loyer} €<br />
                                {rowData.totVolume} m³
                              </div>
                            )}
                          />
                          <Column
                            field="note"
                            header="Notes"
                            bodyStyle={{ fontSize: "13px" }}
                          />
                          <Column
                            className="loc-column-content"
                            header="Actions"
                            style={{ width: "30%" }}
                            body={(rowData) =>
                              localStorage.getItem("pr") === "sad" ||
                              localStorage.getItem("pr") === "st" ||
                              localStorage.getItem("pr") === "ad" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    gap: "5px",
                                  }}
                                >
                                  <Button
                                    icon="pi pi-pencil"
                                    severity="success"
                                    size="small"
                                    text
                                    raised
                                    onClick={() => {
                                      setSelectedLocation(rowData.idLocation);
                                      setIdInfoLoc(rowData.idLocation);
                                      setSelectedNomCli(rowData.nom);
                                      setIdStock(rowData.idStockage);
                                      setModifierLocation(true);
                                    }}
                                  />

                                  <Button
                                    icon="pi pi-trash"
                                    severity="danger"
                                    size="small"
                                    text
                                    raised
                                    onClick={() => {
                                      setSelectedLocation(rowData.idLocation);
                                      setStockageALibrerer(rowData.idStockage);
                                      setSuprLoc(true);
                                    }}
                                  />

                                  <Button
                                    icon="pi pi-euro"
                                    severity="contrast"
                                    size="small"
                                    text
                                    raised
                                    onClick={() => {
                                      setIdInfoLoc(rowData.idLocation);
                                      setSelectedNomCli(rowData.nom);
                                      setIdStock(rowData.idStockage);
                                    }}
                                  />
                                </div>
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    gap: "5px",
                                  }}
                                >
                                  <Button
                                    icon="pi pi-euro"
                                    severity="contrast"
                                    size="small"
                                    text
                                    raised
                                    onClick={() => {
                                      setIdInfoLoc(rowData.idLocation);
                                      setSelectedNomCli(rowData.nom);
                                      setIdStock(rowData.idStockage);
                                      setVisibleBottom(true);
                                    }}
                                  />
                                </div>
                              )
                            }
                          ></Column>
                        </DataTable>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="">
          <Sidebar
            visible={visibleBottom}
            position="bottom"
            onHide={() => setVisibleBottom(false)}
            className="h-[30vh]  "
            style={{ backgroundColor: "#F6F6F6" }} // h-96 correspond à 24rem ou 96 pixels
          >
            <InfoLocation
              idInfoLoc={idInfoLoc}
              idStock={idStock}
              selectedNomCli={selectedNomCli}
            />
          </Sidebar>
        </div>
      </div>
    );
  };


  return <div> {LocationListe()}</div>;
};
